import { styled } from '@linaria/react';
import { fonts, layout, primitives, semantic, space } from '../../theme/tokens';

export const Section = styled.section`
  max-width: ${layout.maxWidth};
  margin: 0 auto;
  padding-top: ${space['space-600']};
  padding-bottom: ${space['space-1600']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding-bottom: ${space['space-2000']};
  }
`;

export const PageSection = styled.section<{ $fullWidth?: boolean }>`
  width: 100%;
  max-width: ${({ $fullWidth }) => ($fullWidth ? 'none' : layout.maxWidth)};
  margin: 0 auto;
  padding: ${space['space-600']} ${space['space-600']};
  overflow: hidden;
  box-sizing: border-box;

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space['space-800']} ${space['space-1200']};
  }

  h2 {
    font-family: ${fonts.heading};
    font-size: ${fonts.size.lg};
    color: ${semantic.text.tertiary};
    margin: 0 0 ${space['space-400']};
    text-transform: uppercase;
    letter-spacing: ${primitives.typography.tracking.wide};
  }
`;

export const TitleRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  margin-bottom: ${space['space-800']};
  gap: ${space['space-300']};
  width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    grid-template-columns: auto 1fr;
    align-items: start;
  }
`;

export const Title = styled.h2`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xl};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
  margin: 0;
  line-height: ${primitives.typography.lineHeight.tight};

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${fonts.size['2xl']};
  }
`;
